module.exports = __webpack_public_path__ + "img/bgd5.8bcfd6cc.png";